import * as wrapActions from "./wrap-actions"

export default function EditorAutosuggestKeywordsPlugin() {
  return {
    statePlugins: {
      editor: {
        wrapActions,
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/editor-autosuggest-keywords/index.js